export const furnitureData = [{
        "id": "1",
        "product": "Furniture",
        "image": "/assets/Furniture/1.jpg",
        "type": "Sofa",
        "brand": "IKEA",
        "model": "ComfortPlus",
        "price": "499.99",
        "category": "Home",
        "description": "A comfortable and modern sofa with plush cushions and a sleek design."
    },
    {
        "id": "2",
        "product": "Furniture",
        "image": "/assets/Furniture/2.jpg",
        "type": "Dining Table",
        "brand": "Wayfair",
        "model": "ElegantDine",
        "price": "899.00",
        "category": "Home",
        "description": "An elegant dining table with solid wood construction and expandable design."
    },
    {
        "id": "3",
        "product": "Furniture",
        "image": "/assets/Furniture/3.jpg",
        "type": "Bed",
        "brand": "Ashley ",
        "model": "DreamRest",
        "price": "799.50",
        "category": "Home",
        "description": "A stylish and comfortable bed with upholstered headboard and durable frame."
    },
    {
        "id": "4",
        "product": "Furniture",
        "image": "/assets/Furniture/4.jpg",
        "type": "Coffee Table",
        "brand": "West Elm",
        "model": "ModernBlend",
        "price": "349.99",
        "category": "Home",
        "description": "A modern coffee table with a blend of materials, adding character to your living room."
    },
    {
        "id": "5",
        "product": "Furniture",
        "image": "/assets/Furniture/5.jpg",
        "type": "Wardrobe",
        "brand": "Houzz",
        "model": "SpaceSaver",
        "price": "599.00",
        "category": "Home",
        "description": "A space-saving wardrobe with versatile storage compartments and sleek appearance."
    },
    {
        "id": "6",
        "product": "Furniture",
        "image": "/assets/Furniture/6.jpg",
        "type": "Bookshelf",
        "brand": "Crate & Barrel",
        "model": "BookHaven",
        "price": "299.50",
        "category": "Home",
        "description": "A functional bookshelf with adjustable shelves, suitable for any room."
    },
    {
        "id": "7",
        "product": "Furniture",
        "image": "/assets/Furniture/7.jpg",
        "type": "Desk",
        "brand": "Staples",
        "model": "WorkPro",
        "price": "199.99",
        "category": "Office",
        "description": "A spacious office desk with ergonomic design and ample storage."
    },
    {
        "id": "8",
        "product": "Furniture",
        "image": "/assets/Furniture/8.jpg",
        "type": "Bar Stool",
        "brand": "Target",
        "model": "UrbanChic",
        "price": "89.00",
        "category": "Home",
        "description": "An urban chic bar stool with a contemporary look, perfect for kitchen islands."
    },
    {
        "id": "9",
        "product": "Furniture",
        "image": "/assets/Furniture/9.jpg",
        "type": "Dresser",
        "brand": "Pottery Barn",
        "model": "RusticCharm",
        "price": "599.99",
        "category": "Home",
        "description": "A rustic dresser with ample storage space and charming distressed finish."
    },
    {
        "id": "10",
        "product": "Furniture",
        "image": "/assets/Furniture/10.jpg",
        "type": "Couch",
        "brand": "Crate & Barrel",
        "model": "ComfyLounge",
        "price": "999.00",
        "category": "Home",
        "description": "A comfortable couch with deep seating and modern design, perfect for lounging."
    },
    {
        "id": "11",
        "product": "Furniture",
        "image": "/assets/Furniture/11.jpg",
        "type": "Side Table",
        "brand": "CB2",
        "model": "MinimalistSide",
        "price": "149.50",
        "category": "Home",
        "description": "A minimalist side table with clean lines, adding functionality to any space."
    },
    {
        "id": "12",
        "product": "Furniture",
        "image": "/assets/Furniture/12.jpg",
        "type": "Bedside Table",
        "brand": "Ethan Allen",
        "model": "ClassicNight",
        "price": "249.00",
        "category": "Home",
        "description": "A classic bedside table with a timeless design and convenient storage."
    }
]